export default "__VITE_ASSET__Cud7phHK__"